import React from "react";

export default function InlineAlert({ tone = "status", children, testId }) {
  return (
    <div className="rr-alert" role={tone === "alert" ? "alert" : "status"} data-testid={testId}>
      {children}
    </div>
  );
}
